<template>
  <el-dialog width="80%" :title="this.currentAction.name + ' ' + $t('c.principalInfo.principalInfo')" :visible.sync="showDialog"
    @close="closeDialog()" :before-close="beforeClose" :close-on-click-modal="false" :append-to-body="true" v-dialogDrag>
    <el-form ref="formRef" v-show="showFirstStep" :rules="formRules" :model="formModel" :disabled="currentAction.value >= 3" label-width="79px">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('c.principalInfo.principalName')" prop="principalName">
            <el-input v-model="formModel.principalName" maxlength="90" :placeholder="$t('c.form.maximumLength') + '90'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('c.principalInfo.principalDesc')" prop="principalDesc">
            <el-input v-model="formModel.principalDesc" autosize type="textarea" maxlength="200" :placeholder="$t('c.form.maximumLength') + '200'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('c.principalInfo.principalType')" prop="principalType">
            <el-radio-group v-model="formModel.principalType">
              <el-radio v-for="item in principalTypeDicts" :key="item.itemCode" :label="item.itemCode">
                {{item.value}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="20" v-if="showSecondStep">
      <el-col :span="24">
        <el-card class="main-body-card">
          <div slot="header" class="card-div-header">
            <span class="span-title">角色列表</span>
          </div>
          <div class="main-body-table card-table">
            <el-table :data="roleIdMdlTable" style="width: 100%" height="240">
              <el-table-column
                prop="name"
                label="角色名称">
              </el-table-column>
              <el-table-column
                prop="desc"
                label="角色描述">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
      <el-col :span="24">
        <notice
          cardTitle="通知列表"
          :actionOfParent="currentAction"
          @listenToCompModifiedEvent="compModifiedEvent"
          :extra="formModel.id"
        ></notice>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button v-show="currentAction.value === 1 && showFirstStep" @click="saveForm()" type="primary">{{ $t('c.dialog.saveAndNext') }}</el-button>
      <el-button v-show="currentAction.value === 2 && showFirstStep" @click="saveForm()" type="primary">{{ $t('c.dialog.save') }}</el-button>
      <el-button v-show="currentAction.value === 2 && showFirstStep" @click="toSecondStep()">{{ $t('c.dialog.next') }}</el-button>
      <el-button v-show="showSecondStep" @click="toFirstStep()">{{ $t('c.dialog.back') }}</el-button>
      <el-button @click.native="closeDialog()">{{ $t('c.dialog.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  selectCountPrincipalInfo,
  insertPrincipalInfo,
  updateAllColumnPrincipalInfo
} from '../../api/sum/PrincipalInfo';
import Notice from '../../page/sys/Notice';
export default {
  // 组件属性对象
  props: {
    principalTypeDicts: Array,
    // 同步更新父对象的属性, 是否显示该对话框
    detailDialogVisible: Boolean,
    // 来自父组件的操作类型参数
    actionOfParent: Object,
    // 当前主表行记录
    currentTableRow: Object
  },
  components: {
    Notice
  },
  // 组件数据对象
  data() {
    return {
      // 是否显示该对话框
      showDialog: true,
      // 表单模型
      formModel: {},
      // 表单模型快照, 与持久化数据同步, 来源于主表记录或者是更新后的返回记录, 用于formModel对比
      formModelSnapshot: {},
      // 表单验证规则
      formRules: {
        principalName: [{ required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }],
        principalType: [{ required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }],
        delete_this_line: []
      },
      // 是否显示第一步页面
      showFirstStep: true,
      // 是否显示第二步页面
      showSecondStep: false,
      // 是否已经有服务端更新
      modified: false,
      // 当前操作类型, ACTION.NEW/ACTION.EDIT/ACTION.VIEW
      currentAction: {},
      roleIdMdlTable: [
        { id: '1', name: '角色1', desc: '角色描述1' }, { id: '2', name: '角色2', desc: '角色描述1' },
        { id: '3', name: '角色1', desc: '角色描述1' }, { id: '2', name: '角色2', desc: '角色描述1' },
        { id: '5', name: '角色1', desc: '角色描述1' }, { id: '2', name: '角色2', desc: '角色描述1' },
        { id: '7', name: '角色1', desc: '角色描述1' }, { id: '2', name: '角色2', desc: '角色描述1' },
        { id: '9', name: '角色1', desc: '角色描述1' }, { id: '2', name: '角色2', desc: '角色描述1' },
        { id: '11', name: '角色1', desc: '角色描述1' }, { id: '2', name: '角色2', desc: '角色描述1' }
      ]
    };
  },
  // 页面首次加载数据
  mounted() {
    this.formModel = Object.assign({}, this.currentTableRow);
    this.formModelSnapshot = Object.assign({}, this.currentTableRow);
    this.currentAction = this.actionOfParent
    if (this.currentAction.value === 3) {
      this.showSecondStep = true;
    }
  },
  methods: {
    /**
     * 保存表单并跳到下一步
     */
    saveForm() {
      this.$refs
        .formRef.validate(valid => {
          if (!valid) {
            this.$message({
              type: 'error',
              message: this.$t('c.form.formMissInfo')
            });
            return;
          }
          // 表单校验成功
          if (this.currentAction.value === 1) {
            this.insert();
          } else {
            this.updateAllColumn();
          }
        });
    },
    /**
     * 上一步
     */
    toFirstStep() {
      this.showSecondStep = false;
      this.showFirstStep = true;
    },
    /**
     * 下一步
     */
    toSecondStep() {
      this.showSecondStep = true;
      this.showFirstStep = false;
    },
    /**
     * 新增插入记录
     */
    async insert() {
      let result = await selectCountPrincipalInfo({ principalName: this.formModel.principalName });
      if (result.data > 0) {
        this.$message({
          type: 'error',
          message: this.$t('c.form.the') + this.$t('c.principalInfo.principalName') + ' [' + this.formModel.principalName + '] ' + this.$t('c.form.alreadyExists')
        });
        return;
      }
      result = await insertPrincipalInfo(this.formModel);
      this.modifyFinished(result);
      // if (result.code === 20000) {
      //   this.modified = true;
      //   this.formModel = Object.assign({}, result.data);
      //   this.formModelSnapshot = Object.assign({}, result.data);
      //   this.currentAction = { value: 2, name: this.$t('c.table.edit') }
      //   this.$message({ type: 'success', message: this.$t('c.dialog.saveSuccess') });
      //   this.toSecondStep();
      // }
    },
    /**
     * 全部字段覆盖更新
     */
    async updateAllColumn() {
      let result = null;
      if (this.isChangedOfUnique()) {
        result = await selectCountPrincipalInfo({ principalName: this.formModel.principalName });
        if (result.data > 0) {
          this.$message({
            type: 'error',
            message: this.$t('c.form.the') + this.$t('c.principalInfo.principalName') + ' [' + this.formModel.principalName + '] ' + this.$t('c.form.alreadyExists')
          });
          return;
        }
      }
      result = await updateAllColumnPrincipalInfo(this.formModel);
      this.modifyFinished(result);
      // if (result.code === 20000) {
      //   this.modified = true;
      //   this.formModel = Object.assign({}, result.data);
      //   this.formModelSnapshot = Object.assign({}, result.data);
      //   this.$message({ type: 'success', message: this.$t('c.dialog.saveSuccess') });
      //   this.toSecondStep();
      // }

      // if (this.isChangedOfUnique()) {
      //   selectCountPrincipalInfo({
      //     principalName: this.formModel.principalName
      //   }).then(result => {
      //     if (result.data > 0) {
      //       this.$message({
      //         type: 'error',
      //         message: this.$t('c.form.the') + this.$t('c.principalInfo.principalName') + ' [' + this.formModel.principalName + '] ' + this.$t('c.form.alreadyExists')
      //       });
      //       return;
      //     }
      //     updateAllColumnPrincipalInfo(this.formModel).then(result => {
      //       if (result.code === 20000) {
      //         this.modified = true;
      //         this.formModel = Object.assign({}, result.data);
      //         this.formModelSnapshot = Object.assign({}, result.data);
      //         this.$message({ type: 'success', message: this.$t('c.dialog.saveSuccess') });
      //         this.toSecondStep();
      //       }
      //     });
      //   });
      //   return;
      // }
      // updateAllColumnPrincipalInfo(this.formModel).then(result => {
      //   if (result.code === 20000) {
      //     this.modified = true;
      //     this.formModel = Object.assign({}, result.data);
      //     this.formModelSnapshot = Object.assign({}, result.data);
      //     this.$message({ type: 'success', message: this.$t('c.dialog.saveSuccess') });
      //     this.toSecondStep();
      //   }
      // });
    },
    /**
     * 变更结束后的收尾处理
     */
    modifyFinished(result) {
      if (result.code === 20000) {
        this.modified = true;
        this.formModel = Object.assign({}, result.data);
        this.formModelSnapshot = Object.assign({}, result.data);
        this.currentAction = { value: 2, name: this.$t('c.table.edit') }
        this.$message({ type: 'success', message: this.$t('c.dialog.saveSuccess') });
        this.toSecondStep();
      }
    },
    /**
     * 有唯一索引的属性是否被修改过
     * @returns boolean true表示修改过 false表示未被修改
     */
    isChangedOfUnique() {
      return this.formModelSnapshot.principalName !== this.formModel.principalName;
    },
    /**
     * 关闭对话框
     */
    closeDialog() {
      if (this.beforeCloseCheck()) {
        this.showDialog = false;
        // 子组件向父组件绑定的属性传值
        this.$emit('update:detailDialogVisible', false)
        if (this.modified) {
          this.$emit('listenToDetailDialogClose', this.currentAction)
        }
      }
    },
    /**
     * 当前组件内的子组件的服务端修改完成事件, 更新组件的服务端更新状态
     */
    compModifiedEvent() {
      this.modified = true;
    },
    /**
     * 对话框关闭前的校验
     * @returns true表示校验通过可以关闭, false表示校验失败不允许关闭
     */
    beforeCloseCheck() {
      // 你的业务校验代码
      return true;
    },
    /**
     * 对话框右上角的×关闭前事件
     * @param done 回调关闭方法
     */
    beforeClose(done) {
      if (this.beforeCloseCheck()) {
        done();
      }
    }
  }
};
</script>

<style lang="scss">
</style>
